import { createTheme } from '@mui/material/styles';

const linaresColors = {
  primary: {
    50: '#ddf3ff',
    100: '#b0d7ff',
    200: '#81bcfd',
    300: '#51a2f9',
    400: '#2287f6',
    500: '#096edd',
    600: '#0055ad',
    700: '#003d7d',
    800: '#00254e',
    900: '#000d20',
  },
};

const muiTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: linaresColors.primary[600],
      light: linaresColors.primary[400],
      dark: linaresColors.primary[800],
    },
    secondary: {
      main: '#52489C',
    },
    background: {
      default: '#f7f7f7',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: 'system-ui, sans-serif',
    h1: { fontFamily: 'Roboto Slab, serif' },
    h2: { fontFamily: 'Roboto Slab, serif' },
    h3: { fontFamily: 'Roboto Slab, serif' },
    h4: { fontFamily: 'Roboto Slab, serif' },
    h5: { fontFamily: 'Roboto Slab, serif' },
    h6: { fontFamily: 'Roboto Slab, serif' },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
});

export default muiTheme;
